import React from "react"
import { T, TraksConsumer } from "../../traks"

const Plan = ({ plan, ...props }) => {
	if (plan === "premium") {
		return <T>Premium</T>
	} else {
		return <T>Compliance</T>
	}
}

export const CompanyPlan = ({ me }) => {
	const plan = me["plan"]

	return (
		<TraksConsumer>
			<Plan plan={plan} />
		</TraksConsumer>
	)
}
